import styles from "./Loader.module.css";
import React, { ReactElement } from "react";
interface LoaderProps {
  message?: string;
}

const Loader = (props: LoaderProps): ReactElement => {
  return (
    <div data-testid="loader" className={styles.loaderContainer}>
      <div className={styles.loader}></div>
      <div className={styles.loaderMessage}>{props.message}</div>
    </div>
  );
};

export default Loader;
